import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Copy, Check, FileText } from 'lucide-react';
import { toast } from 'sonner';

export const ResultPreview = ({ text, onReset }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success('Text wurde in die Zwischenablage kopiert!');
      setTimeout(() => setCopied(false), 3000);
    } catch (err) {
      toast.error('Fehler beim Kopieren des Textes');
      console.error('Copy failed:', err);
    }
  };

  return (
    <Card className="section-card mt-8 border-primary/30">
      <CardHeader>
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-primary/10 rounded-lg">
              <FileText className="w-5 h-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-2xl">Generierter Anamnesetext</CardTitle>
              <CardDescription className="text-base mt-1">
                Strukturierte Dokumentation nach ABCDE & SAMPLER
              </CardDescription>
            </div>
          </div>
          <Button
            onClick={handleCopy}
            data-testid="copy-report-button"
            className="btn-medical gap-2 w-full sm:w-auto"
            size="lg"
          >
            {copied ? (
              <>
                <Check className="w-4 h-4" />
                Kopiert!
              </>
            ) : (
              <>
                <Copy className="w-4 h-4" />
                Text kopieren
              </>
            )}
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="bg-[hsl(var(--section-bg))] border border-[hsl(var(--section-border))] rounded-lg p-6">
          <pre data-testid="generated-report" className="whitespace-pre-wrap break-words font-sans text-sm leading-relaxed text-foreground">
            {text}
          </pre>
        </div>
      </CardContent>
    </Card>
  );
};

export default ResultPreview;
